import { Component, ElementRef, Input, OnInit, ViewChild, isDevMode } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { addDays, addYears } from 'date-fns';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from '../../../models';
import { AdminService, ApiService, AuthService, CalendarService, MessagingService, SessionService } from "../../../services";
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { HeaderComponent } from '../../header/header.component';
import { UscChatAdapter } from '../usc-chat-adapter/usc-chat-adapter';
import { UscChatTemplateDlgComponent } from '../usc-chat-template-dlg/usc-chat-template-dlg.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { UscModalComponent } from '../usc-modal/usc-modal.component';
import { environment } from '../../../../environments/environment';
import { DateTime } from '@syncfusion/ej2-angular-charts';

@Component({
    selector: 'usc-store-header',
    templateUrl: './usc-header.component.html',
    styleUrls: ['./usc-header.component.css']
})

export class UscHeaderComponent implements HeaderComponent, OnInit {
    @Input() data: any;
    @ViewChild("fileDropRef") fileDropEl: ElementRef;


    currentView: string = "view_usc_form_first_impression";
    current_hierarchy: string;
    hierarchies: any;
    current_online_status: string;
    online_statuses: any;
    userLinks: any;
    public something: any;
    searchText: string;
    user: User = new User();
    isDevMode: boolean = false;
    isLeader: boolean = false;
    isAdmin: boolean = false;
    isUSCellRetail: boolean = false;
    isCorpRetail: boolean = false;
    isAgentRetail: boolean = false;
    isInsideSales: boolean = false;
    isTelesales: boolean = false;
    showHierarchy: boolean = false;
    public selectedFiles;
    public chatUserID = 999;
    public chat_adapter: UscChatAdapter = new UscChatAdapter();

    currentViewSub: Subscription;
    openUserChatSub: Subscription;
    userSub: Subscription;
    teamHierarchySub: Subscription;
    userLinksSub: Subscription;
    team_name: string;
    training_videos: any = { };
    // training_videos: any[];
    ipad_training_videos: any[];
    queueing_training_videos: any[];

    enableSmsMessaging: boolean = false;
    currentMessage = new BehaviorSubject(null);
    // onFocus = new BehaviorSubject(null);

    lastCustomerChatPullFinishTime: Date = null;
    lastCustomerChatPullStartTime: Date = null;
    firstCustomerChatPull: boolean = true;
    customerChatPullScheduled: boolean = false;
    customerChatPullInProgress: boolean = false;
    //min_customer_chat_pull_interval:number = 10 * 1000; // 10 sec
    chat_pull_interval_by_user: number = 10 * 1000;
    //max_remaining_time_to_pull:number = 3 * 60 * 1000;  // 3 mins
    currentUser: User = null;
    search_placeholder: string = "Search by Full Name, Company, or Phone Number";
    checkAvailableAppointmentsForToday: boolean = true;     // one time flag on login for consultant to recieve appt assignment
    chatSearchTriggeredBy:string = "INIT";

    constructor(
        public uscStoreService: UscStoreService,
        private ngbModal: NgbModal,
        public apiService: ApiService,
        private authService: AuthService,
        private adminService: AdminService,
        private sessionService: SessionService,
        private messagingService: MessagingService,
        private calendarService: CalendarService
    ) { }

    // ngOnFocus() {
    //     var v = this.onFocus;
    //     window.onfocus = function () {
    //         console.log("ngOnFocus pullCustomerChatOnCommand");
    //         v.next("PULL");
    //     }
    // }

    ngOnInit() {
        this.isDevMode = isDevMode();

        if (this.uscStoreService.isUSCellRetail()) this.search_placeholder = "Search by Full Name or Phone Number";

        // initialize header elements on user retrieval 
        this.userSub = this.authService.currentUser.subscribe(
            currentUser => {
                if (currentUser && currentUser.ID) {
                    this.currentUser = currentUser;
                    this.enableSmsMessaging = this.uscStoreService.isCustomerTextMessagingEnabled();
                    this.chat_pull_interval_by_user = this.uscStoreService.getChatPullInterval(currentUser);
                    // this.ngOnFocus();
                    this.chat_adapter.resetCustomerChats();
                    this.loadCustomerChat();
                    this.chatUserID = parseInt(currentUser.ID);
                    this.chat_adapter.setCurrentUser(currentUser);
                    this.chat_adapter.uscStoreService = this.uscStoreService;
                    this.chat_adapter.enableLanguagePicker(this.uscStoreService.isMultiLanguageEnabled());
                    // set the chat adapter with the displayName of the currentUser
                    this.chat_adapter.setCurrentSender({
                        displayName: currentUser.first_name + ' ' + currentUser.last_name,
                        id: null,
                        chat_related_ID: null,
                        chat_related_type: null,
                        status: null,
                        lastMessage: null,
                        avatar: null
                    });

                    this.user = currentUser;
                    this.current_hierarchy = currentUser.profile;
                    this.isLeader = this.uscStoreService.isLeader();
                    this.isAdmin = this.uscStoreService.isAdmin();
                    this.isUSCellRetail = this.uscStoreService.isUSCellRetail();
                    this.isCorpRetail = this.uscStoreService.isUSCellCorp();
                    this.isAgentRetail = this.uscStoreService.isUSCellAgent();
                    this.isInsideSales = this.uscStoreService.isUSCellInsideSales();
                    this.isTelesales = this.uscStoreService.isUSCellTelesales();
                    // this.training_videos = this.uscStoreService.getWebTrainingVideoLinks();
                    // this.ipad_training_videos = this.uscStoreService.getiPadTrainingVideoLinks();
                    if (currentUser.team_name) {
                        var pos_index = currentUser.team_name.indexOf("Store -");
                        if (pos_index >= 0) {
                            this.team_name = "(" + currentUser.team_name.substring(0, pos_index + "Store".length) + ")";
                        }
                    }


                    this.online_statuses = [
                        { related_type: 'UR', related_ID: currentUser.ID, status_type: 'UserOnline', status: 'Available', text: 'Available' },
                        { related_type: 'UR', related_ID: currentUser.ID, status_type: 'UserOnline', status: 'Unavailable', text: 'Unavailable' },
                        { related_type: 'UR', related_ID: currentUser.ID, status_type: 'UserOnline', status: 'Offline', text: 'Sign Out' }
                    ];
                    this.changeOnlineStatus(this.online_statuses[0]);

                    this.teamHierarchySub = this.adminService.loadTeamHierarchies().subscribe(
                        data => {
                            this.hierarchies = this.adminService.getSwitchableTeamHierarchies(data);
                            // prevent switching to Primary Hiararchy
                            if (this.uscStoreService.isUSCellAgent() && this.currentUser.title == 'Admin/Manager of Agency') {
                                var ma_index = this.hierarchies.findIndex(h => h.name == 'Master Agent');
                                this.hierarchies = [this.hierarchies[ma_index]];
                            }
                        },
                        err => { console.log(err); }
                    );

                    this.userLinksSub = this.adminService.loadUserLinks().subscribe(
                        data => {
                            console.log('user_links', data);
                            this.userLinks = this.adminService.getSwitchableUserLinks(this.user, data);
                        },
                        err => { console.log(err); }
                    );
                }
            });

        this.messagingService.currentRegisteredDevice.subscribe(device => {
            if (device) {
                this.messagingService.removePreviousRegisteredDevices(this.currentUser, device);
            }
        });

        this.messagingService.currentFcmMessage.subscribe(message => {
            if (this.uscStoreService.isFcmPushCommandEnabled() && message) {
                if (this.uscStoreService.isCustomerChatPullMsg(this.currentUser, message)) {
                    this.pullCustomerChatOnCommand();
                } else if (this.uscStoreService.isTelesalesDealAssignment(this.currentUser, message) || this.uscStoreService.isQtracDealAssignment(this.currentUser, message)) {
                    this.uscStoreService.addAssignmentMessage(message);
                    this.sessionService.log("deal assignment");
                } else if (this.uscStoreService.isDailySMSIntroTrackerUpdate(this.currentUser, message)) {
                    this.uscStoreService.setDailySMSIntroLimitExceeded(this.currentUser, message);
                }
            }
        });

        // this.onFocus.subscribe(f => {
        //     //this.pullCustomerChatOnCommand();
        // })

        // post new chat item to server
        this.chat_adapter.newChatItem.subscribe(
            chatItem => {
                this.uscStoreService.saveData(this.uscStoreService.view_customer_chats, 0, chatItem).subscribe(
                    result => {
                        this.sessionService.log("new chat item saved");
                        let chat: any = {}
                        result.forEach(e => {
                            switch (e.key) {
                                case "ct_related_ID": chat.co_ID = e.value; break;
                                case "cfd_uid": chat.cfd_uid = e.value; break;
                                case "ct_ID": chat.ct_ID = e.value; break;
                                case "dl_ID": chat.dl_ID = e.value; break;
                            }
                        });
                        this.chat_adapter.addNewChatItem(chat);
                        if (this.uscStoreService.isFcmPushCommandEnabled() && this.messagingService.deviceRegistered) {
                            var deal = this.chat_adapter.getRelatedDealByChatItem(chat);
                            deal.cfd_hum = "No"; // manually update the "has unread message" flag on reply as FCM push does not update deal record regularly
                            this.uscStoreService.setUpdatedViewItems([deal]);
                        }
                    }, error => { console.log("error saving new chat item"); }
                );
            }
        )

        this.chat_adapter.markRelatedChatAsRead.subscribe(item => {
            var view = this.uscStoreService.getViewByItem(item);
            var sub = this.uscStoreService.processActionOnViewItem(view, item.view_ID, this.uscStoreService.action_mark_chat_as_read, "").subscribe(
                result => { },
                error => console.log(error)
            );
        });

        // chat menu event listener 
        this.chat_adapter.chatMenuClicked.subscribe(
            chatMenu => {
                switch (chatMenu.Id) {
                    case this.chat_adapter.cmShowSmsTemplate.Id:
                        this.showChatTemplateDlg(chatMenu);
                        break;
                    case this.chat_adapter.cmShowLanguagePicker.Id:
                        this.showLanguagePickerDlg(chatMenu);
                        break;
                }
            }
        )

        this.uscStoreService.viewItemUpdated.subscribe(
            item => {
                this.sessionService.log("viewItemUpdated detected");
                if (this.enableSmsMessaging) this.chat_adapter.updateRelatedDeal(item);
            }
        )

        this.currentViewSub = this.uscStoreService.currentView.subscribe(
            view => {
                if (view != this.currentView) {
                    this.currentView = view;
                    if (this.currentView != this.uscStoreService.view_search) {
                        this.searchText = "";
                    }
                }
            }
        )

        this.openUserChatSub = this.uscStoreService.openUserChat.subscribe(
            item => {
                if (this.enableSmsMessaging) this.chat_adapter.openUserChatWindow(item);
            }
        )

        this.uscStoreService.triggerChatItemReload.subscribe(
            value => {
                if (!this.customerChatPullScheduled && !this.customerChatPullInProgress) {
                    this.loadCustomerChat();
                } else {
                    this.scheduleNextChatPull();
                }
            }
        )

        this.uscStoreService.calendarEvents.subscribe(events => {
            if (events != null && this.checkAvailableAppointmentsForToday && !this.isLeader && (this.isCorpRetail || this.isAgentRetail)) {
                this.checkAvailableAppointmentsForToday = false;
                var appointments = [];
                if (events) {
                    var today = new Date();
                    events.forEach(e => {
                        if (e.u_title == "Store") {
                            var event_date = new Date(e.e_date);
                            if (event_date.toString().substring(0, 16) == today.toString().substring(0, 16) && e.dl_account_type == '' && e.e_sub_type.indexOf('Appointment') >= 0) {
                                appointments.push(e);
                            }
                        }
                    })
                }
                if (this.uscStoreService.isUSCellRetail() && appointments.length > 0) {
                    var i = 0;
                    this.processTodaysAppointments(appointments, 0);
                }
            }
        });

        this.uscStoreService.trainingVideosReady.subscribe(ready => {
            if (ready) {
                //this.queueing_training_videos = this.uscStoreService.getQueueingTrainingVideoLinks();
                this.training_videos = this.uscStoreService.getTrainingVideoLinks();
                console.log(this.training_videos);
            }
        });

        this.uscStoreService.portalReady.subscribe(ready => {
            if (ready) {
                this.uscStoreService.getWelcomeMessage().subscribe(item => {
                    if (item) {
                        const modalRef = this.ngbModal.open(UscDialogComponent, { size: "lg", backdrop: 'static', keyboard: false });
                        modalRef.componentInstance.data = { msg: item.content };
                        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_welcome_message;
                        modalRef.result.then(
                            (result) => {
                                modalRef.dismiss();
                                this.uscStoreService.confirmWelcomeMessage();
                            },
                            (reason) => { }
                        );
                    }
                });
            }
        });
    }

    processTodaysAppointments(appointments, i) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.data = appointments[i];
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_appointment_assignment;
        modalRef.result.then(
            (result) => {
                modalRef.dismiss();
                // appointment assignment accepted
                if (result.response == this.uscStoreService.response_appt_accept) this.acceptAppointment(appointments[i]);
                if (i + 1 < appointments.length) {
                    setTimeout(() => { this.processTodaysAppointments(appointments, i + 1) }, 10);
                }
            },
            (reason) => { }
        );
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    acceptAppointment(item) {
        //let dlg = this.showCustomPromptDlg(item, { msg: "Accepting Lead" });
        this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_search, item.dl_ID, this.uscStoreService.action_accept_appointment, "").subscribe(
            result => {
                //dlg.dismiss();
            }
        );
    }

    pullCustomerChatOnCommand() {
        if (!this.customerChatPullScheduled) {
            var now = new Date();
            var last_pull_elasped_time = now.getTime() - this.lastCustomerChatPullStartTime.getTime();
            var remaining_time_to_pull = this.chat_pull_interval_by_user - last_pull_elasped_time;
            if (remaining_time_to_pull < 0) {
                this.chatSearchTriggeredBy = "FCM";
                this.loadCustomerChat();
            } else {
                this.sessionService.log("FCM Customer Chat Pull Message Received: remaining time to pulling ", remaining_time_to_pull);
                this.customerChatPullScheduled = true;
                this.chatSearchTriggeredBy = "SFCM";
                setTimeout(() => {
                    this.loadCustomerChat(true);
                }, remaining_time_to_pull);
            }
        } else {
            this.sessionService.log("FCM Customer Chat Pull Message Received: pulling already scheduled");
        }
    }

    loadCustomerChat(bScheduledPull: boolean = false) {
        if (this.enableSmsMessaging) {
            this.sessionService.log(bScheduledPull ? "Pulling Scheduled Customer Chats..." : "Pulling Customer Chats...");
            var authUser = this.authService.getAuth();
            if (authUser && authUser.ID) {
                this.customerChatPullInProgress = true;
                this.customerChatPullScheduled = false;
                this.lastCustomerChatPullStartTime = new Date();
                var chat_cut_off_date = addYears(new Date(), -1);
                var chat_cut_off_date_string = this.calendarService.getDateText(chat_cut_off_date, 'yyyy-MM-dd');
                // first chat pulls 1 year of chats 
                var params: any = { v: `<${environment.version}-${this.user.ID}-${this.chatSearchTriggeredBy}>`, est: "ST_Search", SP_CT_MODIFIED_DATE_SEARCH: chat_cut_off_date_string };
                // subsequent pulls last 1 day of chats
                if (!this.firstCustomerChatPull) params.SP_CT_MODIFIED_DATE_SEARCH = this.calendarService.getDateText(this.lastCustomerChatPullStartTime, 'yyyy-MM-dd');
                this.uscStoreService.getData(this.uscStoreService.view_customer_chats, params, false).subscribe(
                    result => {
                        this.loadChatRelatedDeals(result);
                        this.firstCustomerChatPull = false;
                    },
                    err => {
                        this.customerChatPullInProgress = false;
                        this.sessionService.log("unable to load Customer Chat, trying again!", err);
                        this.loadCustomerChat(bScheduledPull);
                    }
                );
            }
        }
    }

    // serialize loading of chat related deals
    public pullChatRelatedDealsFailedAttemptLogs:any[] = [];
    private loadChatRelatedDealsBySequential(chatResult, idList, max_batch_count) {
        var params: any = {
            v: `<${environment.version}-${this.user.ID}-${idList.length}-${this.chatSearchTriggeredBy}>`,
            p: 1,
            ob: "dl_ID",
            text: '',
            est: "ST_Search",
            obd: "asc"
        }

        if (idList.length > 0) {
            var batchCount = idList.length > max_batch_count ? max_batch_count : idList.length;
            var batchedIdList = idList.splice(0, batchCount);
            params.idList = batchedIdList.join(",");
            params.ps = batchedIdList.length;
            var idlist_length = idList.length;

            console.log("loadChatRelatedDealsBySequential", params);
            this.uscStoreService.getData(this.uscStoreService.view_search, params, false).subscribe(
                result => {
                    if (result && result.items) {
                        this.chat_adapter.setChatRelatedItems(result.items);
                        // notify any subscriber that deal items maybe changed (impression views may need to update its state ie. SMS icon)
                        this.uscStoreService.setUpdatedViewItems(result.items);
                        // pull complete when all items have synced
                        if (idlist_length == 0) {
                            this.customerChatPullInProgress = false;
                            this.lastCustomerChatPullFinishTime = new Date();
                            this.sessionService.log("Customer Chat loaded @ ", new Date());
                            this.chat_adapter.setCustomerChats(chatResult);
                            this.chat_adapter.setReloadingHandler(false);
                        } else {
                            this.loadChatRelatedDealsBySequential(chatResult, idList, max_batch_count);
                        }
                    }
                    if (idlist_length == 0) {
                        this.scheduleNextChatPull();
                    } 
                },
                err => {
                    this.sessionService.log("unable to get chat related deals. will try again");
                    // if (!this.customerChatPullScheduled) {
                    //     this.loadCustomerChat();
                    // } else {
                    //     this.scheduleNextChatPull();
                    // }
                }
            );            
        }
    }

    // concurrent loading of chat related deals
    protected loadChatRelatedDealsByConcurrency(chatResult, idList, max_batch_count) {
        var params: any = {
            p: 1,
            ob: "dl_ID",
            text: '',
            est: "ST_Search",
            obd: "asc"
        }

        // split the idList into batches of max_batch_count items and pull from server, 
        // each pull from server is async so we need to keep a total count of items pulled to know when we're done 
        // on pull complete, update chat adapter
        var synced_patch = 0;
        var total_sync_patches = Math.ceil(idList.length / max_batch_count);
        var idCount = idList.length;
        while (idCount > 0) {
            var batchCount = idList.length > max_batch_count ? max_batch_count : idList.length;
            var batchedIdList = idList.splice(0, batchCount);
            idCount = idList.length;
            params.idList = batchedIdList.join(",");
            params.ps = batchedIdList.length;

            this.uscStoreService.getData(this.uscStoreService.view_search, params, false).subscribe(result => {
                    if (result && result.items) {
                        synced_patch++;
                        this.chat_adapter.setChatRelatedItems(result.items);
                        // notify any subscriber that deal items maybe changed (impression views may need to update its state ie. SMS icon)
                        this.uscStoreService.setUpdatedViewItems(result.items);
                        // pull complete when all items have synced
                        if (synced_patch >= total_sync_patches) {
                            this.customerChatPullInProgress = false;
                            this.lastCustomerChatPullFinishTime = new Date();
                            this.sessionService.log("Customer Chat loaded @ ", new Date());
                            this.chat_adapter.setCustomerChats(chatResult);
                            this.chat_adapter.setReloadingHandler(false);
                        }
                    }
                    if (synced_patch >= total_sync_patches) this.scheduleNextChatPull();
                },
                err => {
                    this.sessionService.log("unable to get chat related deals. will try again");
                    if (!this.customerChatPullScheduled) {
                        this.loadCustomerChat();
                    } else {
                        this.scheduleNextChatPull();
                    }
                }
            );
        }
    }

    private loadChatRelatedDeals(chatResult) {
        var idList = [];
        if (chatResult && chatResult.items) {
            chatResult.items.forEach(i => {
                if (i.dl_ID && i.dl_ID > 0 && idList.indexOf(i.dl_ID) < 0) {
                    idList.push(i.dl_ID);
                }
            })

            var params: any = {
                p: 1,
                ob: "dl_ID",
                text: '',
                est: "ST_Search",
                obd: "asc"
            }

            this.sessionService.log("Customer Chat loading @ ", new Date());
            var max_batch_count = 100;
            // initialize chat adapter anyway even if there is no chat related deals
            if (idList.length == 0) {
                this.chat_adapter.setCustomerChats(chatResult);
                this.chat_adapter.setReloadingHandler(false);
            } else {
                // 2024-02-08: convert concurrent loading to sequential loading
                this.loadChatRelatedDealsBySequential(chatResult, idList, max_batch_count);
                //this.loadChatRelatedDealsByConcurrency(chatResult, idList, max_batch_count);
            }
        }
    }

    scheduleNextChatPull() {
        if (!this.uscStoreService.isFcmPushCommandEnabled() && !this.customerChatPullScheduled) {
            if (this.customerChatPullInProgress) {
                setTimeout(() => this.scheduleNextChatPull(), this.chat_pull_interval_by_user);  // delay scheduling of another loadCustomerChat until current chat pull is finished
            } else {
                this.customerChatPullScheduled = true;
                this.chatSearchTriggeredBy = "SP";
                setTimeout(() => this.loadCustomerChat(true), this.chat_pull_interval_by_user);  // schedule the next chat pull
            }
        }
    }

    ngOnDestroy() {
        if (this.userSub) this.userSub.unsubscribe();
        if (this.currentViewSub) this.currentViewSub.unsubscribe();
        if (this.teamHierarchySub) this.teamHierarchySub.unsubscribe();
    }

    changeOnlineStatus(status) {
        this.adminService.changeUserOnlineStatus(this.currentUser, status).subscribe(
            item_status => {
                this.current_online_status = status;
                if (status.status == "Offline") this.logOff();
            },
            err => {
                this.sessionService.log("unable to change user online status");
            }
        )
    }

    getOnlineStatusStyle(status) {
        var style = {
            "padding": "4px 8px",
            "background": status && status.status == "Unavailable" ? "#bc272f" : "#21af00",
            "text-align": "center"
        }
        return style;
    }

    switchHierarchy(hierarchy) {
        this.authService.setIsAuthenticated(false);  // reset this promise which is set to true when switch is successful, thus UscStoreComponent.snInit() will reInit portal
        this.adminService.switchHierarchy(hierarchy).subscribe(
            user => {
                this.uscStoreService.clearSvtStoreCaches();  // reset current store in store_visit/queueing
                this.current_hierarchy = user.profile;
                this.firstCustomerChatPull = true;
                this.customerChatPullInProgress = false;
                this.authService.setAuth(user);
            },
            err => {
                this.sessionService.log("unable to switch hierarchy");
            }
        )
    }

    switchLinkedUser(user_link) {
        this.authService.setIsAuthenticated(false);  // reset this promise which is set to true when switch is successful, thus UscStoreComponent.snInit() will reInit portal
        this.adminService.switchLinkedUser(user_link).subscribe(
            user => {
                this.uscStoreService.clearSvtStoreCaches();  // reset current store in store_visit/queueing
                this.current_hierarchy = user_link.alias;
                this.firstCustomerChatPull = true;
                this.customerChatPullInProgress = false;
                this.authService.setAuth(user);
            },
            err => {
                this.sessionService.log("unable to switch user");
            }
        )
    }

    search() {
        this.sessionService.log("search");
        if (this.searchText.length > 0) {
            // by setting the searchText, it will also change view to search 
            this.uscStoreService.setSearchText(this.searchText);
        }
    }

    logOff() {
        this.uscStoreService.setSearchText("");
        this.authService.logoff();
    }

    manageUsers() {
        this.uscStoreService.setCurrentView(this.uscStoreService.view_user_profile);
    }

    manageCampaign() {
        this.uscStoreService.setCurrentView(this.uscStoreService.view_manage_campaigns);
    }

    importCampaign() {
        this.uscStoreService.setCurrentView(this.uscStoreService.view_campaign_import);
    }

    changePassword() {
        this.uscStoreService.setCurrentView(this.uscStoreService.view_change_password);
    }

    showChatTemplateDlg(chatMenu) {
        var chatItems = this.chat_adapter.getChatItemsByWindow(chatMenu.window);
        var item = this.chat_adapter.getRelatedDealByChatItem(chatItems[0]);
        const modalRef = this.ngbModal.open(UscChatTemplateDlgComponent, { size: 'lg', backdrop: 'static', keyboard: false });
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.chat_window = chatMenu.window;
        modalRef.componentInstance.chat_adapter = this.chat_adapter;

        modalRef.result.then((result) => {
            this.chat_adapter.sendMessageHandler(result.chat_window, result.sms);
        }, (reason) => { });
    }

    showLanguagePickerDlg(chatMenu) {
        var chatItems = this.chat_adapter.getChatItemsByWindow(chatMenu.window);
        var item = this.chat_adapter.getRelatedDealByChatItem(chatItems[0]);
        var view = this.uscStoreService.getViewByItem(item);
        // const modalRef = this.ngbModal.open(UscChatTemplateDlgComponent, { size: 'lg', backdrop: 'static', keyboard: false });
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_language_preference;

        modalRef.result.then((pref) => {
            var params = { "cfd_lp": pref.response };
            item.cfd_lp = pref.response;
            this.chat_adapter.setChatRelatedItems([item]);
            this.uscStoreService.processActionOnViewItem(view, item.view_ID, this.uscStoreService.action_update_language_preference, params).subscribe(
                result => { this.sessionService.log("language preference updated: " + pref.response); }
            );
        }, (reason) => { });
    }

    newOLRInternalReferral() {
        //window.open("https://content.business.uscellular.com/referral", "_blank");
        window.open("https://go.pardot.com/l/922813/2021-06-01/2zyj", "_blank");
        // if (this.uscStoreService.isUSCellAgent()) {
        //   window.open("https://content.business.uscellular.com/referral", "_blank");
        // } else {
        //   const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        //   modalRef.componentInstance.view = this.uscStoreService.form_olr_internal_referral;   
        //   let new_lead = { dl_ID: 0 };

        //   modalRef.componentInstance.data = new_lead;
        //   modalRef.result.then((result) => {
        //     this.sessionService.log("internal referral form saved");
        //   }, (reason) => {
        //     this.sessionService.log("internal referral form cancelled");
        //   });
        // }
    }

    gotoSmsHosting() {
        this.uscStoreService.setCurrentView(this.uscStoreService.view_sms_hosting);
    }

    isAgentMaster() {
        return this.isAgentRetail && (this.user.title.indexOf('Master') >= 0 || this.user.title.indexOf('Master') >= 0);
    }

    hasUserLinks(): boolean {
        return this.userLinks && this.userLinks.length > 0;
    }

    allowSwitchHierarchy(): boolean {
        if (!this.isUSCellRetail || this.isTelesales) return false;

        var bHasLinks = this.hasUserLinks();
        var isLeader = (this.isAdmin || (!this.isInsideSales && this.isLeader));
        var bAllow = !bHasLinks && isLeader;
        return bAllow;
    }

    newQuickSale() {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.uscStoreService.form_quick_sale;   // default to lasting impression on new lead
        let new_lead = { dl_ID: 0, co_work_phone1: null, co_firstname: null, co_lastname: null, dl_notes: null };
        modalRef.componentInstance.onCustomValidateEvent = this.onQuickSaleValidation;
        modalRef.componentInstance.onSubmitOverrideEvent = this.onSubmit;
        modalRef.componentInstance.data = new_lead;
        modalRef.result.then((result) => {
            console.log(result);
            let item: any = {};

        }, (reason) => {
            console.log(reason);
        });
    }

    onQuickSaleValidation(services, event, btn_event, newFormFields) {
        var validation = { status: true, error_msg: '' }
        var bIsChargeBack = false, bValid = true;
        newFormFields.forEach(f => { if (f["key"] == "dl_sub_type") bIsChargeBack = f["value"] == "Charge Back"; });
        newFormFields.forEach(f => {
            if (bValid && f["value"] != null && f["value"] != '') {
                switch (f["key"]) {
                    case "dl_postpaid_basic":
                    case "dl_postpaid_everyday":
                    case "dl_postpaid_even_better":
                    case "dl_estimated_units":
                    case "dl_connected_device":
                    case "dl_prepaid":
                    case "dl_hsi":
                    case "dl_bir":
                    case "dl_upgrades_basic":
                    case "dl_upgrades_everyday":
                    case "dl_upgrades_even_better":
                    case "dl_estimated_value":
                    case "dl_estimated_value3":
                    case "dl_estimated_units3":
                    case "cfd_dti":
                    case "dl_estimated_value4":
                    case "dl_estimated_units5":
                    case "cfd_dpb":
                    case "cfd_dps":
                    case "cfd_dpa":
                    case "cfd_dpacs":
                        bValid = bIsChargeBack ? parseInt(f["value"]) <= 0 : parseInt(f["value"]) >= 0;
                        break;
                }
            }
        })
        if (!bValid) {
            if (bIsChargeBack) validation = { status: false, error_msg: 'All Charge Back sales figures must be less or equal to 0.' }
            if (!bIsChargeBack) validation = { status: false, error_msg: 'All Quick Sale figures must be greater or equal to 0.' }
        }
        return validation;
    }

    onSubmit(services, event, btn_event, newFormFields) {
        var params = { event: btn_event };
        var order_ID = 0;
        newFormFields.forEach(f => { if (f["key"] == "cfd_oid") order_ID = f["value"]; });
        var data = { "Order ID": order_ID };

        var reloadP2WAchievements = function () {
            services.uscStoreService.setActionPlan(null);
            services.uscStoreService.setTodaysGoal(null);
            services.uscStoreService.triggerReloadP2WAchievements();
        }

        var showCustomPromptDlg = function (services, msg_config): NgbModalRef {
            const modalRef = services.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
            modalRef.componentInstance.dlgType = services.uscStoreService.dialog_type_custom_msg;
            modalRef.componentInstance.msg_config = msg_config;
            return modalRef;
        }

        let dlg = showCustomPromptDlg(services, { msg: "Validating Order ID" });
        services.uscStoreService.processActionOnViewItem(services.uscStoreService.form_quick_sale, 0, services.uscStoreService.action_quick_sale_order_id_query, data).subscribe(
            result => {
                dlg.dismiss();
                if (result.data.sale_type && result.data.sales_figures) {
                    const modalRef = services.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                    modalRef.componentInstance.parentView = services.uscStoreService.form_quick_sale;
                    modalRef.componentInstance.dlgType = services.uscStoreService.dialog_type_quick_sale_details;
                    modalRef.componentInstance.data = result.data;
                    modalRef.componentInstance.quick_sale = newFormFields;
                    modalRef.result.then((r) => {
                        if (r.response) {
                            dlg = showCustomPromptDlg(services, { msg: "Updating Sales..." });
                            this.uscStoreService.saveOutcome(services.uscStoreService.form_quick_sale, 0, newFormFields, params).subscribe(
                                result => {
                                    dlg.dismiss();
                                    reloadP2WAchievements();
                                    if (services.activeModal) services.activeModal.close({ event: btn_event, data: null });
                                }
                            );
                        }
                    });
                } else {
                    let dlg = showCustomPromptDlg(services, { msg: "Processing Sales..." });
                    this.uscStoreService.saveOutcome(services.uscStoreService.form_quick_sale, 0, newFormFields, params).subscribe(
                        result => {
                            dlg.dismiss();
                            reloadP2WAchievements();
                            if (services.activeModal) services.activeModal.close({ event: btn_event, data: null });
                        }
                    );
                }
            }, error => {
            }
        );
    }


    files: any[] = [];
    onFileDropped($event) {
        this.prepareFilesList($event);
    }

    /**
     * handle file from browsing
     */
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        if (this.files[index].progress < 100) {
            console.log("Upload in progress.");
            return;
        }
        this.files.splice(index, 1);
    }

    /**
     * Simulate the upload process
     */
    uploadFilesSimulator(index: number) {
        setTimeout(() => {
            if (index === this.files.length) {
                return;
            } else {
                const progressInterval = setInterval(() => {
                    if (this.files[index].progress === 100) {
                        clearInterval(progressInterval);
                        this.uploadFilesSimulator(index + 1);
                    } else {
                        this.files[index].progress += 5;
                    }
                }, 200);
            }
        }, 1000);
    }

    /**
     * Convert Files list to normal array list
     * @param files (Files List)
     */
    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            item.progress = 0;
            this.files.push(item);
        }
        this.fileDropEl.nativeElement.value = "";
        this.uploadFilesSimulator(0);
    }

    /**
     * format bytes
     * @param bytes (File size in bytes)
     * @param decimals (Decimals point)
     */
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
}




// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-header/usc-header.component.ts